exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".BlockButtonGroup-b620feb7{display:flex;margin-bottom:30px}.BlockButtonGroup-b620feb7 .groupItem-dcd52445{margin:0px 10px;background:#fff;border:1px solid #BDBDBD;border-radius:5px;flex-grow:0;flex-shrink:1;padding:20px}.BlockButtonGroup-b620feb7 .groupItem-dcd52445:first-child{margin-left:0px}.BlockButtonGroup-b620feb7 .groupItem-dcd52445:last-child{margin-right:0px}.BlockButtonGroup-b620feb7 .groupItem-dcd52445.selected-fff9f435{border:2px solid #FA6400}\n", ""]);

// Exports
exports.locals = {
	"BlockButtonGroup": "BlockButtonGroup-b620feb7",
	"groupItem": "groupItem-dcd52445",
	"selected": "selected-fff9f435"
};